
<template>

  <div class="wrapper">
    <v-contactmodal></v-contactmodal>

    <v-sidebar activeNavItem="navLink2"></v-sidebar>

    <div class="main-panel">

      <v-navbar v-bind:title="isAdd ? 'Create RFQ' : 'Edit RFQ'"></v-navbar>

      <div class="content" v-on:click="dissmissAutoCompletes()">

        <div class="row">
          <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Customer</h4>
                </div>
                <div class="card-body">
                  <div class="form row">
                    <div class="col-9">
                      <div class="row">

                        <div class="col-6">
                          <div class="form-group">
                            <label>Company</label>
                            <input type="text" autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
                            class="form-control" v-on:keyup="customerCompanyLiveSearch()" v-model="customercompany" v-validate="'required'" :disabled="isContractRFQ || customerSaved">
                            <div id="customerCompanyLiveSearch" class="customLiveSearch">
                              <template v-for="(customerrow, index) in customercompanyrows">
                                <div :key="index" class="customLiveSearchElement" v-on:click="customerCompanySelected(customerrow)">{{ customerrow.display }}</div>
                              </template>
                            </div>
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="form-group">
                            <label>Name</label>
                            <input type="text" autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
                            class="form-control" v-on:keyup="customerLiveSearch()" v-model="customername" v-validate="'required'" :disabled="isContractRFQ || customerSaved">
                            <div id="customerCustomLiveSearch" class="customLiveSearch">
                              <template v-for="(customerrow, index) in customerrows">
                                <div :key="index" class="customLiveSearchElement" v-on:click="customerSelected(customerrow)">{{ customerrow.display }}</div>
                              </template>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-3 col-md-6">
                          <div class="form-group"  id="customerPO">
                            <label for="customerpo">PO #</label>
                            <div class="form-group">
                              <input id="customerpo" type="text" v-model="customerpo" class="form-control" >
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-3 col-md-6">
                          <div class="form-group"  id="customerSales">
                            <label for="customersales">Sales #</label>
                            <div class="form-group">
                              <input id="customersales" type="text" v-model="customersales" class="form-control" >
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-3 col-md-6">
                          <div class="form-group"  id="customerTransferOrder">
                            <label for="customertransferorder">Transfer Order #</label>
                            <div class="form-group">
                              <input id="customertransferorder" type="text" v-model="customertransferorder" class="form-control" :disabled="true" >
                            </div>
                          </div>
                        </div>


                        <div class="col-lg-3 col-md-6">
                          <div class="form-group">
                            <label for="customer_terms">Terms</label>
                            <select class="form-control" v-model="terms" id="customer_terms">
                              <option id="termsdefault">EXW Ex-Works</option>
                              <option>FCA Free Carrier</option>
                              <option>CPT Carriage Paid To</option>
                              <option>CIP Carriage &amp; Insurance Paid To</option>
                              <option>DAT Delivered at Terminal</option>
                              <option>DAP Delivered at Place</option>
                              <option>DDP Delivered Duty Paid</option>
                              <option>FAS Free Alongside Ship</option>
                              <option>FOB Free on Board</option>
                              <option>CFR Cost&amp;FreightForwarderServices</option>
                              <option>CIF Cost.Insurance &amp; Freigh </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <div class="form-group">
                            <label for="customerduedate">Due Date</label>
                            <div class="form-group">
                              <input id="customerduedate" type="text" class="form-control datetimepicker" v-model="duedate">
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="col-3">
                      <!-- <img src="/static/img/spiral.png" class="spiral"> -->
                      <div class="rolodex">
                        {{customercompany}}
                        <br> {{customeraddress}}
                        <br> {{customercity}} {{customerprovince}}
                        <br> {{customerpostal}}
                        <br> {{customercountry}}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Shipper</h4>
                </div>
                <div class="card-body">
                  <div class="form row">
                    <div class="col">

                      <div class="form-group">
                        <label>Company</label>
                        <input type="text" autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
                        class="form-control" v-on:keyup="shipperCompanyLiveSearch()" v-model="companyname" v-validate="'required'">
                        <div id="shipperCompanyLiveSearch" class="customLiveSearch">
                          <template v-for="(shipperrow, index) in shippercompanyrows">
                            <div :key="'shipper_'+index" class="customLiveSearchElement" v-on:click="shipperCompanySelected(shipperrow)">{{ shipperrow.display }}</div>
                          </template>
                        </div>
                      </div>

                      <div class="form-group">
                        <label>Name</label>
                        <input type="text" class="form-control" v-on:keyup="shipperLiveSearch()" v-model="shippername" v-validate="'required'">
                        <div id="shipperCustomLiveSearch" class="customLiveSearch">
                          <template v-for="(shipperrow, index) in shipperrows">
                            <div :key="'shipper_'+index" class="customLiveSearchElement" v-on:click="shipperSelected(shipperrow)">{{ shipperrow.display }}</div>
                          </template>
                        </div>
                      </div>

                      <div class="form-group"  id="companyPO">
                        <label for="companypo">PO #</label>
                        <div class="form-group">
                          <input id="companypo" type="text" v-model="companypo" class="form-control" >
                        </div>
                      </div>

                      <div class="form-group"  id="companyRelease">
                        <label for="companyrelease">Release #</label>
                        <div class="form-group">
                          <input id="companyrelease" type="text" v-model="companyrelease" class="form-control" >
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="companyduedate">Pick Up</label>
                        <div class="form-group">
                          <input id="companyduedate" type="text" v-model="companyduedate" class="form-control datetimepicker" name="pickup date" v-validate="'required|validDate'">
                        </div>
                      </div>


                      <div class="form-group">
                        <label for="companyliftgate">Lift Gate</label>
                        <select class="form-control" v-model="companyliftgate">
                          <option id="liftgatedefault">No</option>
                          <option>Yes</option>
                        </select>
                      </div>



                      <div class="form-group">
                        <label for="shipper_appt">Appointment</label>
                        <select class="form-control" v-model="appointment" @change="apptChange()">
                          <option>No</option>
                          <option>Yes</option>
                        </select>
                      </div>

                      <div class="form-group"  id="contactNameInput" style="display:none">
                        <label for="contactname">Contact Name</label>
                        <div class="form-group">
                          <input id="contactname" type="text" v-model="contactname" class="form-control" >
                        </div>
                      </div>

                      <div class="form-group"  id="contactPhoneInput" style="display:none">
                        <label for="contactphone">Contact Phone</label>
                        <div class="form-group">
                          <input id="contactphone" type="text" v-model="contactphone" class="form-control" >
                        </div>
                      </div>

                    </div>

                    <div class="col">
                      <!-- <img src="/static/img/spiral.png" class="spiral"> -->
                      <div class="rolodex">
                        {{companyname}}
                        <br> {{companyaddress}}
                        <br> {{companycity}} {{companyprovince}}
                        <br> {{companypostal}}
                        <br> {{companycountry}}
                      </div>
                      <LeafletMap
                        v-if="companyAddressCoordinates"
                        height="200px"
                        :starting-center="[companyAddressCoordinates.lat, companyAddressCoordinates.lng]"
                        :points="[{center: [companyAddressCoordinates.lat, companyAddressCoordinates.lng]}]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">

              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Consignee</h4>
                </div>
                <div class="card-body">
                  <div class="form row">
                    <div class="col">

                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label>Company</label>
                            <input type="text" class="form-control" v-on:keyup="consigneeCompanyLiveSearch()" v-model="consigneecompany" v-validate="'required'">
                            <div id="consigneeCompanyLiveSearch" class="customLiveSearch">
                              <template v-for="(consigneerow, index) in consigneecompanyrows">
                                <div :key="'consigneerow_'+index" class="customLiveSearchElement" v-on:click="consigneeCompanySelected(consigneerow)">{{ consigneerow.display }}</div>
                              </template>
                            </div>
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="form-group">
                            <label>Name</label>
                            <input type="text" autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
                            class="form-control" v-on:keyup="consigneeLiveSearch()" v-model="consigneename" v-validate="'required'">
                            <div id="consigneeCustomLiveSearch" class="customLiveSearch">
                              <template v-for="(consigneerow, index) in consigneerows">
                                <div :key="'consigneerow_'+index" class="customLiveSearchElement" v-on:click="consigneeSelected(consigneerow)">{{ consigneerow.display }}</div>
                              </template>
                            </div>
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="form-group"  id="consigneePO">
                            <label for="consigneepo">PO #</label>
                            <div class="form-group">
                              <input id="consigneepo" type="text" v-model="consigneepo" class="form-control" >
                            </div>
                          </div>
                        </div>


                        <div class="col-12">
                          <div class="form-group">
                            <label for="consigneedate">Delivery Date</label>
                            <div class="form-group">
                              <input id="consigneedate" type="text" class="form-control datetimepicker" v-model="consigneedate" name="delivery date" v-validate="'required|validDate'">
                            </div>
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="form-group">
                            <label for="truck_liftgate">Lift Gate</label>
                            <select class="form-control" v-model="consigneeliftgate">
                              <option id="liftgatedefault">No</option>
                              <option>Yes</option>
                            </select>
                          </div>
                        </div>



                        <div class="col-12">

                          <div class="form-group">
                            <label for="consigneeappointment">Appointment</label>
                            <select class="form-control" v-model="consigneeappointment" @change="consigneeapptChange()" id="consigneeappointment">
                              <option>No</option>
                              <option>Yes</option>
                            </select>
                          </div>

                          <div class="form-group" id="consigneecontactNameInput" style="display:none">
                            <label for="consigneecontactname">Contact Name</label>
                            <div class="form-group">
                              <input id="consigneecontactname" type="text" v-model="consigneecontactname" class="form-control" >
                            </div>
                          </div>

                          <div class="form-group" id="consigneecontactPhoneInput" style="display:none">
                            <label for="consigneecontactphone">Contact Phone</label>
                            <div class="form-group">
                              <input id="consigneecontactphone" type="text" v-model="consigneecontactphone" class="form-control" >
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>
                    <div class="col">
                      <!-- <img src="/static/img/spiral.png" class="spiral"> -->
                      <div class="rolodex">
                        {{consigneecompany}}
                        <br>{{consigneeaddress}}
                        <br> {{consigneecity}} {{consigneeprovince}}
                        <br> {{consigneepostal}}
                        <br> {{consigneecountry}}
                      </div>
                      <LeafletMap
                        v-if="consigneeAddressCoordinates"
                        height="200px"
                        :starting-center="[consigneeAddressCoordinates.lat, consigneeAddressCoordinates.lng]"
                        :points="[{center: [consigneeAddressCoordinates.lat, consigneeAddressCoordinates.lng]}]"
                      />
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        <div class="row">
          <div class="col">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Truck</h4>
              </div>
              <div class="card-body">
                <div class="form row">
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_trailertype">Trailer Type</label>
                      <select class="form-control" v-model="trailertype">
                        <option id="trailertypedefault">TBD</option>
                        <option>Dry Van</option>
                        <option>Flatbed</option>
                        <option>Container Chassis</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_suspensiontype">Suspension Type</label>
                      <select class="form-control" v-model="suspensiontype">
                        <option id="suspensiontypedefault">TBD</option>
                        <option>Spring</option>
                        <option>Air Ride</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_temperaturecontrol">Temperature Control</label>
                      <select class="form-control" v-model="tempcontrol">
                        <option id="tempcontroldefault">N/A</option>
                        <option>Reefer Fresh</option>
                        <option>Reefer Frozen</option>
                        <option>Heated</option>
                      </select>
                    </div>
                  </div>



                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_driverassist">Driver Assist</label>
                      <select class="form-control" v-model="driverassist">
                        <option id="driverassistdefault">No</option>
                        <option>Yes</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_mode">Mode</label>
                      <select class="form-control" v-model="mode">
                        <option id="stackabledefault">TBD</option>
                        <option>FTL</option>
                        <option>LTL</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="truck_service">Service</label>
                      <select class="form-control" v-model="service">
                        <option id="servicedefault">Standard</option>
                        <option>Overnight</option>
                        <option>Expedited</option>
                      </select>
                    </div>
                  </div>


                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="consigneecod">COD</label>
                      <select class="form-control" v-model="truckcod" id="consigneecod">
                        <option id="consigneecoddefault">Yes</option>
                        <option>No</option>
                      </select>
                    </div>
                  </div>


                  <div class="col-xs-1 col-sm-4 col-md-3">
                    <div class="form-group">
                      <label for="dunnagerequired">Dunnage Required</label>
                      <input type="text" class="form-control" v-model="dunnagerequired" maxlength="128">
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-8 col-md-6">
                    <div class="form-group">
                      <label for="truck_special">Special Instructions</label>
                      <textarea name="truck_special" id="truck_special" class="form-control" cols="30" rows="10" maxlength="2048" v-model="specialinstructions"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="col">

            <div class="card">
              <div class="card-header">

              <div class="row">
                <div class="col-9">
                  <h4 class="card-title">Shipping Units</h4>
                </div>
                <div class="col-1">
                  <div class="text-right">
                  <label for="shippingDimensionUnits">Units</label>
                  </div>
                </div>
                <div class="col-2">
                  <select id="shippingDimensionUnits" class="form-control" v-model="shippingDimensionUnits" @change="onDimensionChange($event)">
                    <option>in/lbs</option>
                    <option>in/kgs</option>
                    <option>cm/lbs</option>
                    <option>cm/kgs</option>
                  </select>
                </div>
              </div>

              </div>
              <div class="card-body">
                <div class="table-responsive">
                    
                    <table class="table table-borderless"> 
                        <thead>
                            <tr>
                                <th class="text-center squeeze"></th>
                                <th class="text-left" colspan="3" style="min-width: 320px; max-width: 320px;">Description / Lot</th>
                                <th class="text-center">Quantity</th>
                                <th class="text-center">Stackable</th>
                                <th class="text-center">Length {{suunitlength}}</th>
                                <th class="text-center">Width {{suunitlength}}</th>
                                <th class="text-center">Height {{suunitlength}}</th>
                                <th class="text-center">Weight {{suunitweight}}</th>
                                <th class="text-center">Hazard</th>
                                <th class="text-left" style="min-width: 120px; max-width: 120px;">Contents</th>
                                <th class="text-center squeeze"></th>
                            </tr>
                        </thead>
                        <tbody>
                        <template v-for="(row,shipIndex) in rows">
                          <TertiaryRow :key="'tertiary_'+shipIndex" :customerCompanyEntity="customercompanyentity" :row="row" :shipIndex="shipIndex"
                          :readOnly="!isDispatchable"
                          v-on:removeRow="removeShippingUnit(shipIndex)"
                          v-on:cloneRow="duplicateShippingUnit(row, shipIndex)"
                          />
                        </template>
                        </tbody>
                    </table>
                    
                </div>
                <div class="d-block text-right">
                    
                    <!-- <button class="btn btn-primary"><i class="fa fa-plus-circle"></i> Add Container or Product <i class="fa fa-chevron-down ml-3"></i></button> -->

                    <button class="btn btn-success" :disabled="!isDispatchable" v-on:click="addShippingUnit()"><i class="fa fa-plus"></i> Add Row</button>


                    <template v-if="!!customerSaved && customercompanyentity === DIVA_COMPANY_ID && !isAdd">
                      <button class="btn btn-success" :disabled="!isDispatchable" v-on:click="fulfillShipment()" > Item Fullfillment</button>
                      <span v-if="this.rfq.dispatchStatus != 'Pending'"><i class="fa fa-check" aria-hidden="true"></i>Ready</span>
                      <p v-if="this.loading"><ThreeDots></ThreeDots></p>
                      <p class="help is-danger" v-if="fulfillErrorDetails">{{fulfillErrorDetails}}</p>
                    </template>
                </div>

              </div>
            </div>

          </div>
        </div>
        
        <ShippingSummary
          v-if="rows.length > 0"
          ref="summary"
          v-bind:rfq="rfq"
          v-bind:rows="rows"
        ></ShippingSummary>

        <UploadDocument v-if="!isAdd"
          :showGenerate=true
          :documents="documents"
          :rfqId="rfqIdOnly"
          :rfq="rfq"
          @fileUploaded="saveDocumentToRFQ"
          @deleteUploadedDocument="deleteDocument"
        />

        <UploadDocument v-if="isAdd"
          :showGenerate="false"
          :documents="documents"
          :saveLocal="true"
          @fileAdded="addFileToLocalDocuments"
          @deleteLocalDocument="deleteLocalDocument"
        />

        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Assignee(s)</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col">
                <table class="table" v-if="rfqAssignees.length > 0">
                  <thead>
                    <tr>
                      <th>Company</th>
                      <th>Name</th>
                      <th>Due Date</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>

                    <template v-for="(rfqAssignee,index) in rfqAssignees">
                      <tr :key="index">

                        <td style="position: relative;">
                          <div class="form-group"> 
                            <input type="text" :id="'assigneecompany' + index" name="assigneecompany" v-on:keyup="assigneeCompanyLiveSearch(index, rfqAssignee)" v-model="rfqAssignee.assigneeCompany" class="form-control" autocomplete="off">
                            <div :id="'assigneeCompanyLiveSearch' + index" class="customLiveSearch" style="margin-top: -16px; width: 90%;">
                              <template v-for="(assigneerow, idx) in assigneecompanyrows">
                                <div :key="idx" class="customLiveSearchElement" v-on:click="assigneeCompanySelected(index, rfqAssignee, assigneerow)">{{ assigneerow.display }}</div>
                              </template>
                            </div>
                          </div>
                        </td>

                        <td style="position: relative;">
                          <div class="form-group">
                            <input type="text" autocapitalize="off" autocomplete="off" autocorrect="off" autofocus="" role="combobox" spellcheck="false"
                            :id="'assignee' + index" name="assignee" v-on:keyup="assigneeLiveSearch(index, rfqAssignee)" v-model="rfqAssignee.assigneeName" class="form-control">
                            <div :id="'assigneeCustomLiveSearch' + index" class="customLiveSearch" style="margin-top: -16px; width: 90%;">
                              <template v-for="(assigneerow, idx) in assigneerows">
                                <div :key="idx" class="customLiveSearchElement" v-on:click="assigneeSelected(index, rfqAssignee, assigneerow)">{{ assigneerow.display }}</div>
                              </template>
                            </div>

                          </div>
                        </td>

                        <td>
                          <div class="form-group">
                            <input :id="'assigneedue' + index" type="text" class="form-control datetimepicker" v-model="rfqAssignee.duedate">
                          </div>
                        </td>
                        <td class="text-right">
                          <button type="button" class="btn btn-link btn-danger" v-on:click="removeAssignee(index)"><i class="fa fa-fw fa-trash"></i></button>
                        </td>
                      </tr>
                    </template>

                  </tbody>
                </table>

                <button class="btn btn-icon btn-xs btn-success" :disabled="!rfqAssignees || (isContractRFQ && rfqAssignees.length > 0) || !consigneeaddress || !consigneedate || !companyaddress || !companyduedate" v-on:click="addAssignee()" style="margin-top:-7px"><i class="fa fa-plus"></i> Add Assignee</button>
                <small class="text-muted" v-if="isContractRFQ"> This is a contract RFQ with one assignee and will have the quote set and awarded automatically.</small>

              </div>
            </div>
          </div>
        </div>

        <div>
          <span>{{lastEdit}}</span>
        </div>

        <div class="text-right">

          <!-- Hidden validation -->
          <div v-show="false">
            <input type="text" v-model="companyaddress" name="ShipperAddress" v-validate="'required'">
            <input type="text" v-model="consigneeaddress" name="ConsigneeAddress" v-validate="'required'">
          </div>
          <!-- show validation only if submitting RFQ -->
          <div v-show="showErrors">
            <p :key="'error_'+index" v-for="(error,index) in errors.all()" class="help is-danger">{{ error }}</p>
            <p :key="'owerror_'+index" v-for="(msg,index) in overweightMsg" class="help is-danger">{{ msg }}</p>
          </div>

          <button v-on:click="cancelRFQ()" :disabled='loading' class="btn btn-simple btn-link btn-wd"><i class="fa fa-times"></i> Cancel</button>
          <button v-on:click="saveRFQ(true)" :disabled='loading' class="btn btn-normal btn-wd"><i class="fa fa-save"></i> Save Draft</button>
          <button v-on:click="beforeSendRFQ()" :disabled='loading' class="btn btn-success btn-wd"><i class="fa fa-send"></i> Release</button>
          <div v-if="loading" class="col" >
            <ThreeDots></ThreeDots> <span class="loading text-muted">Saving...</span>
          </div>
        </div>
      </div>

      <v-footer></v-footer>

    </div>
  </div>

</template>


<script>
import Vue from 'vue'

import apiService from '../../services/api.service'
import entityService from '../../services/entity.service'
import companyService from '../../services/company.service'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import Footer from '../../components/AppFooter'
import ContactModal from '../../components/ContactModal'
import LeafletMap from '../../views/map/LeafletMap'

import TertiaryRow from '../../components/shippinglvls/TertiaryRow.vue';
import UploadDocument from '../../components/UploadDocument'
import ShippingSummary from "../../components/ShippingSummary";

import "../../../static/js/bootstrap-datetimepicker.js"

import { fixError } from '../../utils/http'
import { validateDeliveryAfterPickup, isArrayForTransferOrderEmpty } from '../../utils/validation'
import { DIVA_COMPANY_ID, RUTHERFORD_ID  } from "../../constants/entities";

import { ThreeDots } from 'vue-loading-spinner'

//auto-complete for main RFQ inputs
var customercompanyrows = [ ]
var customerrows = [ ]

var shippercompanyrows = [ ]
var shipperrows = [ ]

var consigneecompanyrows = [ ]
var consigneerows = [ ]

var allCompanies = [ ];
var assigneecompanyrows = [ ]
var assigneerows = [ ]

var productrows = [ ]

//shippingunit rows
var rows = [ ]

// support multiple assignees
var rfqAssignees = [ ]



export default {
  name: 'RFQAdd',
  components: {
    'v-sidebar': Sidebar,
    'v-navbar': Navbar,
    'v-footer': Footer,
    'v-contactmodal': ContactModal,
    TertiaryRow,
    LeafletMap,
    UploadDocument,
    ThreeDots,
    ShippingSummary
  },
  watch: {
    consigneeaddress: function (newValue, oldValue) {
      this.resetAssigneesIfNull(newValue)
    },
    consigneedate: function (newValue, oldValue) {
      this.resetAssigneesIfNull(newValue)
    },
    companyaddress: function (newValue, oldValue) {
      this.resetAssigneesIfNull(newValue)
    },
    companyduedate: function (newValue, oldValue) {
      this.resetAssigneesIfNull(newValue)
    }, 
  },

  async beforeRouteLeave (to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    if (this.isAdd) {
      console.log("----------------------------- leaving create RFQ page");
      sessionStorage.removeItem("newRFQ");
      if (sessionStorage.clearRFQ == null) {
        const newRFQ = await this.composeRFQ(true);
        console.log(newRFQ);
        sessionStorage.newRFQ = JSON.stringify(newRFQ);
        console.log(sessionStorage.newRFQ);
      }

      sessionStorage.removeItem("clearRFQ");
    }
    next();
  },

  async mounted () {

    $(document).ready(function() {
      $('input').attr('autocomplete', 'nope'+Math.random());
    });

    this.$validator.localize('en', {
      custom: {
        ShipperAddress: {
          required: 'The shipper address is required.'
        },
        ConsigneeAddress: {
          required: 'The consignee address is required.'
        }
      }
    });

    const vm = this

    vm.$on('populateContact', function (contactModal) {
      console.log("on populateContact " + sessionStorage["lastContactModal"] + "_id set to: " + contactModal.modal_id);
      if (sessionStorage["lastContactModal"] == "customer")
      {
        if (!this.customercompany || this.customercompany != contactModal.modal_company) {
            this.customeraddress = contactModal.modal_address
            this.customerpostal = contactModal.modal_postal
            this.customercity = contactModal.modal_city
            this.customerprovince = contactModal.modal_province
            this.customercountry = contactModal.modal_country
            this.customerdivision = contactModal.modal_division;
            this.customercompanyentity = contactModal.modal_company_entity;

            if (contactModal.modal_name != null && contactModal.modal_name.length > 0) {
              this.customercompany = contactModal.modal_name;
            }
            if (contactModal.modal_company != null && contactModal.modal_company.length > 0) {
              this.customercompany = contactModal.modal_company;
            }
        }
        this.customername = contactModal.modal_name;
        this.customerEntity = contactModal.modal_id
      }
      else if (sessionStorage["lastContactModal"] == "shipper")
      {
        if (!this.companyname || this.companyname != contactModal.modal_company) {
          
          this.companyaddress = contactModal.modal_address
          this.companypostal = contactModal.modal_postal
          this.companycity = contactModal.modal_city
          this.companyprovince = contactModal.modal_province
          this.companycountry = contactModal.modal_country
          this.companydivision = contactModal.modal_division
          this.shipperentity = contactModal.modal_company_entity
          this.companyAddressCoordinates = contactModal.addressCoordinates

          if (contactModal.modal_name != null && contactModal.modal_name.length > 0) {
            this.companyname = contactModal.modal_name;
          }
          if (contactModal.modal_company != null && contactModal.modal_company.length > 0) {
            this.companyname += ", " + contactModal.modal_company;
          }
        }
        this.shippername = contactModal.modal_name
        this.companyentity = contactModal.modal_id
      }
      else if (sessionStorage["lastContactModal"] == "consignee")
      {
        if (!this.consigneecompany || this.consigneecompany != contactModal.modal_company) {
          this.consigneeaddress = contactModal.modal_address
          this.consigneepostal = contactModal.modal_postal
          this.consigneecity = contactModal.modal_city
          this.consigneeprovince = contactModal.modal_province
          this.consigneecountry = contactModal.modal_country
          this.consigneedivision = contactModal.modal_division
          this.consigneeCompanyEntity = contactModal.modal_company_entity
          this.consigneeAddressCoordinates = contactModal.addressCoordinates

          if (contactModal.modal_name != null && contactModal.modal_name.length > 0) {
            this.consigneename = contactModal.modal_name;
          }
          if (contactModal.modal_company != null && contactModal.modal_company.length > 0) {
            this.consigneename += ", " + contactModal.modal_company;
          }
        }
        this.consignename = contactModal.modal_name;
        this.consigneEntity = contactModal.modal_id
      }
      else if (sessionStorage["lastContactModal"] == "assignee")
      {
        var index = Number(sessionStorage["lastContactModalIndex"]);
        var assignee = rfqAssignees[index];
        document.getElementById('assignee' + index).value = contactModal.modal_name
        var vAssigner = localStorage.getItem('local_id')
        assignee.assignerid = vAssigner
        assignee.assigneeid = contactModal.modal_id

        if (contactModal.modal_name != null && contactModal.modal_name.length > 0) {
          assignee.assigneeName = contactModal.modal_name;
        }
        if (contactModal.modal_company != null && contactModal.modal_company.length > 0) {
          assignee.assigneeName += ", " + contactModal.modal_company;
        }
        if (contactModal.modal_division != null && contactModal.modal_division.length > 0) {
          assignee.assigneeName += " - " + contactModal.modal_division;
        }

        if (!assignee.assigneeCompany || assignee.assigneeCompany != contactModal.modal_company) {
          assignee.assigneeCompany = contactModal.modal_company;
        }

        console.log(JSON.stringify(rfqAssignees))
      }
    });


    if (rfqAssignees != null)
    {
      console.log("-----------clear assignees")
      while (rfqAssignees.length > 0) rfqAssignees.pop();
    }

    if (rows != null)
    {
      console.log("-----------clear shipping items")
      while (rows.length > 0) rows.pop();
    }


    // Get the RFQ Details
    let newRFQ = { 
      shippingunit: [],
      customer: {},
      shipper: {},
      consignee: {},
      truck: {},
    };

    if (this.isAdd) {
      // try and restore in progress RFQ from session
      console.log("add mode");
      if (sessionStorage.newRFQ != null) {
        newRFQ = JSON.parse(sessionStorage.newRFQ);
      }
      this.rfq = newRFQ;
      console.log("done init add RFQ");
    } else {
      const response = await apiService.get('/kong/api/v1/rfq/id/', {
        headers: { 'X-Raefton-RFQ-ID': this.$route.params.id }
      });
      this.rfq = response.data.Result;
      newRFQ = response.data.Result;
    }

    console.log( JSON.stringify(newRFQ, null, 2) );
    this.loadEditingRFQ(newRFQ);

    setTimeout(() => initDatePickers('.datetimepicker'), 1000)

    // Get companies
    companyService.get().then(res => allCompanies = res) ;
  },


  data: function () {
    return {
      rfq: null,
      rfqIdOnly: extractRFQId(this.$route.params.id),
      showErrors: false,
      shipperrows: shipperrows,
      shippercompanyrows: shippercompanyrows,
      customerrows: customerrows,
      customercompanyrows: customercompanyrows,
      consigneerows: consigneerows,
      consigneecompanyrows: consigneecompanyrows,
      assigneerows: assigneerows,
      assigneecompanyrows: assigneecompanyrows,
      productrows: productrows,
      rows: rows,
      rfqAssignees: rfqAssignees,
      appointment: 'No',
      customerpo: '',
      customersales: '',
      customertransferorder: '',
      customeraddress: '',
      customerpostal: '',
      customercity: '',
      customerprovince: '',
      customercountry: '',
      customercompany: '',
      customercompanyentity: '',
      customername: '',
      customerdivision: '',
      customerEntity: '',
      terms: '',
      duedate: '',
      companyname: '',
      shippercompanyentity: '',
      shippername: '',
      companypo: '',
      companyrelease: '',
      companyaddress: '',
      companypostal: '',
      companycity: '',
      companyprovince: '',
      companycountry: '',
      companydivision: '',
      companyduedate: '',
      companyAddressCoordinates: null,
      consigneename: '',
      consigneeEntity: '',
      consigneeCompanyEntity: '',
      consigneecompany: '',
      consigneepo: '',
      consigneeaddress: '',
      consigneepostal: '',
      consigneecity: '',
      consigneeprovince: '',
      consigneecountry: '',
      consigneedivision: '',
      consigneeappointment: 'No',
      consigneeAddressCoordinates: null,
      truckcod: '',
      consigneedate: '',
      trailertype: '',
      suspensiontype: '',
      tempcontrol: '',
      companyliftgate: 'No',
      consigneeliftgate: 'No',
      driverassist: 'No',
      mode: '',
      service: '',
      dunnagerequired: '',
      specialinstructions: '',
      contactname: '',
      contactphone: '',
      consigneecontactname: '',
      consigneecontactphone: '',
      liveSearching: false,
      shippingUnits: [],
      overweightMsg: [],
      documents: [],
      customerSaved: false,
      DIVA_COMPANY_ID: DIVA_COMPANY_ID,
      RUTHERFORD_ID: RUTHERFORD_ID,
      changelog: [],
      loading: false,
      fulfillErrorDetails: null,
      shippingDimensionUnits: 'in/lbs',
    }
  },
  computed: {
    isAdd: function() { return !this.$route.params.id },
    lastEdit: function () {
      if(!this.changelog || this.changelog.length === 0) {
        return "No data about last edit"
      }
      const lastEntry = this.changelog[this.changelog.length - 1]
      let message =  `Last Edited by: ${lastEntry.user}`
      const date = new Date(lastEntry.date)
      message += date ? ` on ${date.toLocaleDateString()} at ${date.toLocaleTimeString()}` : '';
      return message;
    },
    isDispatchable: function() {
      return this.rfq && this.rfq.dispatchStatus != 'FulFilled';
    },

    isContractRFQ: function() {
      if (!this.rfq || !this.rfq.assignees || !rfqAssignees) return false;
      return ((this.rfq.assignees[0] && RUTHERFORD_ID.includes(this.rfq.assignees[0].assigneeCompanyId))
            || (rfqAssignees[0] && RUTHERFORD_ID.includes(rfqAssignees[0].assigneeCompanyId)))
          && this.customercompanyentity == DIVA_COMPANY_ID;
    },
    suunitlength: function() {
      const [lengthUnits, weightUnits] = this.shippingDimensionUnits.split('/');
      return `(${lengthUnits})`;
    },
    suunitweight: function() {
      const [lengthUnits, weightUnits] = this.shippingDimensionUnits.split('/');
      return `(${weightUnits})`;
    },
  },
  methods: {

    loadEditingRFQ(newRFQ) {
      if (newRFQ.assignees != null) {
        newRFQ.assignees.map((assignee) => {
          assignee.duedate = serverTimeToLocal(assignee.dueDateTime);
          this.rfqAssignees.push(assignee);
          apiService.get(`/kong/api/v1/entity/id`, {headers: { 'X-Raefton-ID': assignee.assigneeid} })
          .then(function (response) {
            Vue.set(assignee, 'name', response.data.Result.name);
          })
          .catch(function (error) {
            console.log("assignee load error", error);
          })
        });
      }

      for (var i = 0; i < newRFQ.shippingunit.length; i++) {
        var shipItem = {};

        this.shippingDimensionUnits = newRFQ.shippingunit[i].unitsofmeasure;
        let [lengthUnits, weightUnits] = newRFQ.shippingunit[i].unitsofmeasure.split('/');
        shipItem.internalId = newRFQ.shippingunit[i].internalId;
        shipItem.description = newRFQ.shippingunit[i].description;
        shipItem.type = newRFQ.shippingunit[i].type
        shipItem.quantity = newRFQ.shippingunit[i].quantity;
        shipItem.length = newRFQ.shippingunit[i].length;
        shipItem.width = newRFQ.shippingunit[i].width;
        shipItem.height = newRFQ.shippingunit[i].height;
        shipItem.weight = newRFQ.shippingunit[i].weight;
        shipItem.unitlength = lengthUnits === 'undefined' ? '' : lengthUnits;
        shipItem.unitweight = weightUnits === 'undefined' ? '' : weightUnits;
        shipItem.apiIntegration = newRFQ.shippingunit[i].apiIntegration;
        shipItem.lot = newRFQ.shippingunit[i].lot;
        shipItem.unitsPerCase = newRFQ.shippingunit[i].unitsPerCase;
        shipItem.stackable = newRFQ.shippingunit[i].stackable;
        shipItem.hazardous = newRFQ.shippingunit[i].hazardous == 'Yes' || newRFQ.shippingunit[i].hazardous === true ? true : false;
        shipItem.cargorows = newRFQ.shippingunit[i].cargo;
        shipItem.components = newRFQ.shippingunit[i].components;
        rows.push(shipItem);
      }

      this.customerSaved = !!newRFQ.customer.entity;
      this.appointment = newRFQ.customer.appointment;
      this.customeraddress = newRFQ.customer.address;
      this.customerpostal = newRFQ.customer.postal;
      this.customercity = newRFQ.customer.city;
      this.customerprovince = newRFQ.customer.province;
      this.customercountry = newRFQ.customer.country;
      this.customercompany = newRFQ.customer.company;
      this.customercompanyentity = newRFQ.customer.companyEntity;
      this.customername = newRFQ.customer.name;
      this.customersales = newRFQ.customer.sales;
      this.customertransferorder = newRFQ.customer.transferOrder;
      this.customerpo = newRFQ.customer.po;
      this.customerdivision = newRFQ.customer.division;
      this.customerEntity = newRFQ.customer.entity;
      this.terms = newRFQ.customer.terms;
      this.duedate = serverTimeToLocal(newRFQ.customer.dueDateTime);

      this.shippername = newRFQ.shipper.name;
      this.shipperentity = newRFQ.shipper.entity;
      this.companyname = newRFQ.shipper.company;
      this.shippercompanyentity = newRFQ.shipper.companyEntity;
      this.companydivision = newRFQ.shipper.division;
      this.companyaddress = newRFQ.shipper.address;
      this.companypostal = newRFQ.shipper.postal;
      this.companycity = newRFQ.shipper.city;
      this.companyprovince = newRFQ.shipper.province;
      this.companycountry = newRFQ.shipper.country;
      this.companypo = newRFQ.shipper.po;
      this.companyAddressCoordinates = newRFQ.shipper.addressCoordinates;
      this.companyrelease = newRFQ.shipper.release;
      this.companyduedate = serverTimeToLocal(newRFQ.shipper.pickupDateTime);
      this.companyliftgate = newRFQ.shipper.liftgate;
      this.appointment = newRFQ.shipper.appointment ? "Yes" : "No";
      this.contactname = newRFQ.shipper.contactname;
      this.contactphone = newRFQ.shipper.contactphone;

      this.consigneename = newRFQ.consignee.name;
      this.consigneecompany = newRFQ.consignee.company;
      this.consigneeEntity = newRFQ.consignee.entity;
      this.consigneeCompanyEntity = newRFQ.consignee.companyEntity;
      this.consigneedivision = newRFQ.consignee.division;
      this.consigneeaddress = newRFQ.consignee.address;
      this.consigneepostal = newRFQ.consignee.postal;
      this.consigneecity = newRFQ.consignee.city;
      this.consigneeprovince = newRFQ.consignee.province;
      this.consigneecountry = newRFQ.consignee.country;
      this.consigneeAddressCoordinates = newRFQ.consignee.addressCoordinates;
      this.consigneeappointment = newRFQ.consignee.appointment ? "Yes" : "No";
      this.consigneeliftgate = newRFQ.consignee.liftgate;
      this.consigneepo = newRFQ.consignee.po;
      this.consigneedate = serverTimeToLocal(newRFQ.consignee.deliveryDateTime);
      this.consigneecontactname = newRFQ.consignee.contactname;
      this.consigneecontactphone = newRFQ.consignee.contactphone;

      this.trailertype = newRFQ.truck.trailertype;
      this.suspensiontype = newRFQ.truck.suspensiontype;
      this.tempcontrol = newRFQ.truck.tempcontrol;
      this.truckcod = newRFQ.truck.consigneecod ? "Yes" : "No";
      this.driverassist = newRFQ.truck.driverassist;
      this.mode = newRFQ.truck.mode;
      this.service = newRFQ.truck.service;
      this.dunnagerequired = newRFQ.truck.dunnagerequired;
      this.specialinstructions = newRFQ.truck.specialinstructions;

      this.documents = newRFQ.documents;
      this.changelog = newRFQ.changelog;

      if (newRFQ.shipper.appointment == true) {
        $("#contactNameInput").show();
        $("#contactPhoneInput").show();
      }

      if (newRFQ.consignee.appointment == true) {
        $("#consigneecontactNameInput").show();
        $("#consigneecontactPhoneInput").show();
      }
      
    },

    resetAssigneesIfNull: function(value) {
      const assigneeSaved = this.rfq.assignees != null && this.rfq.assignees.length > 0;
      
      // only reset if assignee has not been saved yet
      if(!assigneeSaved && !value) {
        this.removeAssignee(0);
      }
    },

    addCargoUnit: function (shipIndex, row) {
      row.cargorows.push({cargonumber: row.cargorows.length + 1, hazardousgoods: "Yes"})
    },

    removeCargoUnit: function (cargoIndex, row) {
      row.cargorows.splice(cargoIndex, 1);
    },

    shipperLiveSearch: function (event) {
      // Check if anything has been submitted
      var entry = this.shippername
      if (entry.length < 3) {
        this.dissmissAutoCompletes();
      } else {
        this.liveSearching = true;
        const vm = this;

        // Find Matches
        entityService.get(entry)
        .then(function (res) {
          console.log('shipperLiveSearch: ' + JSON.stringify(res.data))

          // Pop everything off
          var len = shipperrows.length;
          for (var j = 0; j < len; j++) {
            shipperrows.pop()
          }

          shipperrows.push({email:"", name: "Add New", id: "-1", display: "Add New"})
          shipperrows.push( ...res.data.filter(row => !vm.companyname || vm.companyname == row.company));
        })
        .catch(function (error) {
          console.log('shipper auto complete error');
          console.log(error);
          while(shipperrows.length > 0) { shipperrows.pop(); }
          shipperrows.push({email:"", name: "Add New", id: "-1", display: "Add New"})
        }).finally(() => this.showAutoComplete("shipperCustomLiveSearch"));
        // Sort it all
        shipperrows.sort()
      }
    },

    shipperCompanyLiveSearch: function (event) {
      // Check if anything has been submitted
      var entry = this.companyname
      if (entry.length < 3) {
        this.dissmissAutoCompletes();
        this.resetShipperCompany();
      } else {
        this.liveSearching = true;

        // Find Matches 
        var postData = "s=" + entry;
        apiService.post('/kong/api/v1/company/globalsearch/', postData, { headers: { 'X-Search': entry }})
        .then(function (response) {

          // Pop everything off
          var len = shippercompanyrows.length;
          for (var j = 0; j < len; j++) {
            shippercompanyrows.pop()
          }

          var reslen = response.data.Result.length
          for (var i = 0; i < reslen; i++) {

            var shipperRow = {
              id: response.data.Result[i].id,
              company: response.data.Result[i].company,
              address: response.data.Result[i].address,
              postal: response.data.Result[i].postal,
              city: response.data.Result[i].city,
              province: response.data.Result[i].province,
              country: response.data.Result[i].country,
              division: response.data.Result[i].division,
              display: response.data.Result[i].company,
              addressCoordinates: response.data.Result[i].addressCoordinates,
            };

            if (shipperRow.division != null && shipperRow.division.length > 0) shipperRow.display += " - " + shipperRow.division;
            if (shipperRow.city != null) shipperRow.display += ", " + shipperRow.city;

            shippercompanyrows.push(shipperRow)
          }

        })
        .catch(function (error) {

          console.log('shipper company auto complete error: ' + JSON.stringify(error))
          while(shippercompanyrows.length > 0) { shippercompanyrows.pop(); }
        }).finally(() => this.showAutoComplete("shipperCompanyLiveSearch"));
        // Sort it all
        shippercompanyrows.sort()
      }
    },

    shipperSelected: function (row) {
      console.log("shipperSelected", row);
      this.liveSearching = false;
      this.dissmissAutoCompletes();
      if (row.id == "-1") {
        sessionStorage["lastContactModal"] = "shipper";
        this.$modal.show('addCustomerModal')
      } else {
        this.shipperentity = row.id
        this.shippername = row.name;
        if (!this.companyname) {
          this.shippercompanyentity = row.companyObject._id
          this.companyaddress = row.address
          this.companypostal = row.postal
          this.companycity = row.city
          this.companyprovince = row.province
          this.companycountry = row.country
          this.companydivision = row.division
          this.companyAddressCoordinates = row.addressCoordinates
          this.companyname = row.company;
        }
        console.log("shipperentity set to " + row.id)
      }
    },

    shipperCompanySelected: function (row) {
      console.log("shipperCompanySelected", row);
      this.liveSearching = false;
      this.dissmissAutoCompletes();

      this.shippername = "";
      this.shippercompanyentity = row.id;
      this.companyaddress = row.address
      this.companypostal = row.postal
      this.companycity = row.city
      this.companyprovince = row.province
      this.companycountry = row.country
      this.companydivision = row.division
      this.companyAddressCoordinates = row.addressCoordinates
      this.companyname = row.company;
      console.log("shippercompanyentity set to " + row.id);
    },

    customerCompanyLiveSearch: function (event) {
      // Check if anything has been submitted
      console.log("customerCompanyLiveSearch");
      var entry = this.customercompany
      if (entry.length < 3) {
        this.dissmissAutoCompletes();
        this.resetCustomerCompany();
      } else {
        this.liveSearching = true;

        // Find Matches 
        var postData = "s=" + entry;
        apiService.post('/kong/api/v1/company/globalsearch/', postData, { headers: { 'X-Search': entry }})
        .then(function (response) {

          // clear the autocomplete array
          var len = customercompanyrows.length;
          for (var j = 0; j < len; j++) {
            customercompanyrows.pop()
          }

          var reslen = response.data.Result.length
          for (var i = 0; i < reslen; i++) {

            var customerRow = {
              id: response.data.Result[i].id,
              company: response.data.Result[i].company,
              address: response.data.Result[i].address,
              postal: response.data.Result[i].postal,
              city: response.data.Result[i].city,
              province: response.data.Result[i].province,
              country: response.data.Result[i].country,
              division: response.data.Result[i].division,
              display: response.data.Result[i].company
            };

            if (customerRow.division != null && customerRow.division.length > 0) customerRow.display += " - " + customerRow.division;
            if (customerRow.city != null) customerRow.display += ", " + customerRow.city;
            customercompanyrows.push(customerRow)
          }
        })
        .catch(function (error) {
          console.log('customer company auto complete error: ' + JSON.stringify(error))
          while(customercompanyrows.length > 0) { customerrows.pop(); }
        }).finally(() => this.showAutoComplete("customerCompanyLiveSearch"));
        // Sort it all
        customercompanyrows.sort()
      }
    },

    customerLiveSearch: function (event) {
      // Check if anything has been submitted
      console.log("customerLiveSearch");
      const vm = this;
      var entry = this.customername
      if (entry.length < 3) {
        this.dissmissAutoCompletes();
      } else {
        this.liveSearching = true;

        // Find Matches
        entityService.get(entry)
        .then(function (res) {

          // clear the autocomplete array
          var len = customerrows.length;
          for (var j = 0; j < len; j++) {
            customerrows.pop()
          }

          customerrows.push({email:"", name: "Add New", id: "-1", display: "Add New"})
          customerrows.push( ...res.data.filter(row => !vm.customercompany || vm.customercompany == row.company));
        })
        .catch(function (error) {
          console.log('customer auto complete error');
          console.log(error);
          while(customerrows.length > 0) { customerrows.pop(); }
          customerrows.push({email:"", name: "Add New", id: "-1", display: "Add New"})
        }).finally(() => this.showAutoComplete("customerCustomLiveSearch"));
        // Sort it all
        customerrows.sort()
      }
    },

    customerSelected: function (row) {
      console.log("customerSelected");
      this.liveSearching = false;
      this.dissmissAutoCompletes();
      console.log( JSON.stringify(row) );
      if (row.id == "-1") {
        this.$modal.show('addCustomerModal')
        sessionStorage["lastContactModal"] = "customer";
      } else {
        this.customerEntity = row.id
        this.customername = row.name;
        if (!this.customercompany) {
          // if they have not selected a company, get the address info from the contact
          this.customercompanyentity = row.companyObject._id
          this.customeraddress = row.address
          this.customerpostal = row.postal
          this.customercity = row.city
          this.customerprovince = row.province
          this.customercountry = row.country
          this.customercompany = row.company;
          this.customerdivision = row.division
        }
      }
      console.log( `customername: ${this.customername}` );
    },

    customerCompanySelected: function (row) {
      console.log("customerCompanySelected");
      this.liveSearching = false;
      this.dissmissAutoCompletes();
      console.log( JSON.stringify(row, null, 2) );

      this.customercompanyentity = row.id;
      this.customername = "";
      this.customeraddress = row.address
      this.customerpostal = row.postal
      this.customercity = row.city
      this.customerprovince = row.province
      this.customercountry = row.country
      this.customercompany = row.company;
      this.customerdivision = row.division
    },

    dissmissAutoCompletes: function() {
      console.log("dissmissAutoCompletes");
      $(".customLiveSearch").hide();
    },

    showAutoComplete: function(id) {
      if(this.$store.getters.isContactModalOpen || !this.liveSearching) return;
      document.getElementById(id).style.display = 'block';
    },

    consigneeCompanyLiveSearch: function (event) {
      // Check if anything has been submitted
      var entry = this.consigneecompany
      if (entry.length < 3) {
        this.dissmissAutoCompletes();
        this.resetConsigneeCompany();
      } else {
        this.liveSearching = true;

        // Find Matches 
        var postData = "s=" + entry;
        apiService.post('/kong/api/v1/company/globalsearch/', postData, { headers: { 'X-Search': entry }})
        .then(function (response) {

          // Pop everything off
          var len = consigneecompanyrows.length;
          for (var j = 0; j < len; j++) {
            consigneecompanyrows.pop()
          }

          var reslen = response.data.Result.length
          for (var i = 0; i < reslen; i++) {

            var consigneeRow = {
              id: response.data.Result[i].id,
              company: response.data.Result[i].company,
              address: response.data.Result[i].address,
              postal: response.data.Result[i].postal,
              city: response.data.Result[i].city,
              province: response.data.Result[i].province,
              country: response.data.Result[i].country,
              division: response.data.Result[i].division,
              display: response.data.Result[i].company,
              addressCoordinates: response.data.Result[i].addressCoordinates,
            };

            if (consigneeRow.division != null && consigneeRow.division.length > 0) consigneeRow.display += " - " + consigneeRow.division;
            if (consigneeRow.city != null) consigneeRow.display += ", " + consigneeRow.city;

            consigneecompanyrows.push(consigneeRow);
          }

        })
        .catch(function (error) {

          console.log('consignee auto complete error: ' + JSON.stringify(error))
          while(consigneecompanyrows.length > 0) { consigneecompanyrows.pop(); }

        }).finally(() => this.showAutoComplete("consigneeCompanyLiveSearch"));
        // Sort it all
        consigneecompanyrows.sort()
      }
    },

    consigneeLiveSearch: function (event) {
      // Check if anything has been submitted
      var entry = this.consigneename;
      var vm = this;
      if (entry.length < 3) {
        this.dissmissAutoCompletes();
      } else {
        this.liveSearching = true;

        // Find Matches
        entityService.get(entry)
        .then(function (res) {

          // Pop everything off
          var len = consigneerows.length;
          for (var j = 0; j < len; j++) {
            consigneerows.pop()
          }

          consigneerows.push({email:"", name: "Add New", id: "-1", display: "Add New"})
          consigneerows.push( ...res.data.filter(row => !vm.consigneecompany || vm.consigneecompany == row.company));
        })
        .catch(function (error) {
          console.log('consignee auto complete error');
          console.log(error);
          while(consigneerows.length > 0) { consigneerows.pop(); }
          consigneerows.push({email:"", name: "Add New", id: "-1", display: "Add New"})

        }).finally(() => this.showAutoComplete("consigneeCustomLiveSearch"));
        // Sort it all
        consigneerows.sort()
      }
    },

    consigneeCompanySelected: function (row) {
      console.log("consigneeCompanySelected", row);

      this.liveSearching = false;
      this.dissmissAutoCompletes();
      console.log( JSON.stringify(row) );
      if (row.id == "-1") {
        sessionStorage["lastContactModal"] = "consignee";
        this.$modal.show('addCustomerModal')
      } else {
        this.consigneename = "";
        this.consigneecompany = row.company
        this.consigneeCompanyEntity = row.id
        this.consigneeaddress = row.address
        this.consigneepostal = row.postal
        this.consigneecity = row.city
        this.consigneeprovince = row.province
        this.consigneecountry = row.country
        this.consigneedivision = row.division
        this.consigneeAddressCoordinates = row.addressCoordinates
      }
      console.log("consigneeCompanyEntity set to " + row.id);
    },

    consigneeSelected: function (row) {
      console.log("consigneeSelected", row);

      this.liveSearching = false;
      this.dissmissAutoCompletes();
      console.log( JSON.stringify(row) );
      if (row.id == "-1") {
        sessionStorage["lastContactModal"] = "consignee";
        this.$modal.show('addCustomerModal')
      } else {
        this.consigneeEntity = row.id
        this.consigneename = row.name;
        if (!this.consigneecompany) {
          this.consigneeCompanyEntity = row.companyObject._id
          this.consigneecompany = row.companyObject.company
          this.consigneeaddress = row.address
          this.consigneepostal = row.postal
          this.consigneecity = row.city
          this.consigneeprovince = row.province
          this.consigneecountry = row.country
          this.consigneedivision = row.division
          this.consigneeAddressCoordinates = row.addressCoordinates
        }
        console.log("consigneeEntity set to " + row.id)
      }

    },

    assigneeCompanyLiveSearch: function (index, assignee) {

      // Check if anything has been submitted
      if (assignee.assigneeCompany.length < 3) {
        this.dissmissAutoCompletes();
        this.resetAssignee(index);
      } else {
        this.liveSearching = true;

        // Find Matches 
        apiService.post('/kong/api/v1/company/globalsearch/', "", { headers: { 'X-Search': assignee.assigneeCompany }})
        .then(function (response) {

          // Pop everything off
          var len = assigneecompanyrows.length;
          for (var j = 0; j < len; j++) {
            assigneecompanyrows.pop()
          }

          var reslen = response.data.Result.length
          for (var i = 0; i < reslen; i++) {
            var assigneeRow = {
              id: response.data.Result[i].id,
              assigneeCompany: response.data.Result[i].company,
              division: response.data.Result[i].division,
              city: response.data.Result[i].city,
              display: response.data.Result[i].company
            };
            if (assigneeRow.division != null && assigneeRow.division.length > 0) assigneeRow.display += " - " + assigneeRow.division;
            if (assigneeRow.city != null) assigneeRow.display += ", " + assigneeRow.city;
            assigneecompanyrows.push(assigneeRow)
          }
        })
        .catch(function (error) {

          console.log('assignee company auto complete error: ' + JSON.stringify(error))
          while(assigneecompanyrows.length > 0) { assigneecompanyrows.pop(); }

        }).finally(() => this.showAutoComplete('assigneeCompanyLiveSearch' + index));
        // Sort it all
        assigneecompanyrows.sort()
      }
    },

    assigneeLiveSearch: function (index, assignee) {
      console.log(index + JSON.stringify(assignee))
      // Check if anything has been submitted
      if (assignee.assigneeName.length < 3) {
        this.dissmissAutoCompletes();
        this.resetAssignee(index);
      } else {
        this.liveSearching = true;

        // Find Matches
        entityService.get(assignee.assigneeName)
        .then(function (res) {

          // Pop everything off
          var len = assigneerows.length;
          for (var j = 0; j < len; j++) {
            assigneerows.pop()
          }

          assigneerows.push({email:"", name: "Add New", id: "-1", display: "Add New"})
          assigneerows.push(
            ...res.data
              .filter(row => !assignee.assigneeCompany || assignee.assigneeCompany == row.company)
              .map((row) => {
                if (row.company != null && row.company.length > 0) row.display += ", " + row.company;
                if (row.division != null && row.division.length > 0) row.display += " - " + row.division;
                if (row.city != null) row.display += ", " + row.city;
                return row;
              }));
        })
        .catch(function (error) {

          console.log('assignee auto complete error: ' + JSON.stringify(error))
          while(assigneerows.length > 0) { assigneerows.pop(); }
          assigneerows.push({email:"", name: "Add New", id: "-1", display: "Add New"})

        }).finally(() => this.showAutoComplete('assigneeCustomLiveSearch' + index));
        // Sort it all
        assigneerows.sort()
      }
    },

    assigneeCompanySelected: function (index, assignee, row) {
      console.log('assignee comp selected: ' + JSON.stringify(row))
      this.liveSearching = false;
      this.dissmissAutoCompletes();
      document.getElementById('assigneecompany' + index).value = row.assigneeCompany
      assignee.assigneeCompany = row.assigneeCompany
      assignee.assigneeCompanyId = row.id;
      assignee.assigneeName = "";
	  assignee.name = ""; /// from add
    },

    assigneeSelected: function (index, assignee, row) {
      console.log(index + ' edit: ' + JSON.stringify(assignee))
      console.log('selected: ' + JSON.stringify(row))

      this.liveSearching = false;
      this.dissmissAutoCompletes();
      if (row.id == "-1") {
        sessionStorage["lastContactModal"] = "assignee";
        sessionStorage["lastContactModalIndex"] = ""+index;
        this.$modal.show('addCustomerModal')
      } else {
        document.getElementById('assignee' + index).value = row.name
        var vAssigner = localStorage.getItem('local_id')
        var companyRow = allCompanies.find(x => x.company === row.company);
        console.log(' rfqAssignees' + JSON.stringify(rfqAssignees))
        assignee.assignerid = vAssigner
        assignee.assigneeid = row.id
        assignee.assigneeCompanyId = companyRow.id;
        assignee.assigneeCompany = companyRow.company
        assignee.po = companyRow.po
        assignee.address = companyRow.address
        assignee.postal = companyRow.postal
        assignee.city = companyRow.city
        assignee.province = companyRow.province
        assignee.country = companyRow.country
        assignee.assigneeName = row.name
        console.log(JSON.stringify(rfqAssignees))
      }
    },

    addShippingUnit: function () {

      var lastRow = rows.length - 1;
      if (lastRow >= 0)
      {
        if (rows[lastRow].description == null || rows[lastRow].description.length == 0)
        {
          Vue.toasted.error("Please enter a description for this shipping unit", { duration: 3500 })
          return;
        }
      }

      rows.push({
        timestamp: Date.now(),
        type: "Skid",
        internalId: "",
        description: "",
        quantity: "1",
        length: "1",
        width: "1",
        height: "1",
        weight: "1",
        unitlength: "in",
        unitweight: "lbs",
        stackable: false,
        hazardous: false,
        cargorows: [],
        components: []
      });
    },

    duplicateShippingUnit: function (row, shipIndex) {
      const rowCopy = {
        ...row,
        cargorows: row.cargorows ? [...row.cargorows] : [],
        components: row.components.map(secondaryLvl => ({
          ...secondaryLvl,
          components: secondaryLvl.components.map(primaryLvl => ({...primaryLvl}))
        }))
      }
      rows.splice(shipIndex + 1, 0, rowCopy)
    },

    removeShippingUnit: function (index) {
      console.log('remove ' + index);
      if (rows.length > 0) {
        rows.splice(index,1);
      }
    },

    addShippingLvl(unit) {
      this.$modal.show("shipping-lvl-modal", { parent: unit, level: 2 });
    },

    editShippingRow(unit) {
      console.log('modal click');
      console.log(unit);
      this.$modal.show("shipping-modal", { parent: unit });
    },

    addAssignee: function (event) {
      console.log('add another blank assignee here!')
      rfqAssignees.push({})
      console.log(JSON.stringify(rfqAssignees))
      setTimeout(() => initDatePickers('.datetimepicker'), 1000);
    },
    removeAssignee: function (index) {
      console.log('remove ' + index)
      rfqAssignees.splice(index,1);
      console.log(JSON.stringify(rfqAssignees))
    },

    beforeSendRFQ: async function () {
      this.showErrors = true;
      this.$validator.errors.clear();
      await this.$validator.validateAll();
      validateDeliveryAfterPickup(this.companyduedate, this.consigneedate, 'delivery date', this.$validator.errors);
      const isNone = value => value === null || value === undefined;
      const hasNotLatOrLng = value => !value || isNone(value.lat) || isNone(value.lng);

      if(this.companyaddress && hasNotLatOrLng(this.companyAddressCoordinates)) {
        this.$validator.errors.add({
          field: "Shipper Address Cordinates",
          msg: "Could not find shipper address coordinates."
        });
      }

      if(this.consigneeaddress && hasNotLatOrLng(this.consigneeAddressCoordinates)) {
        this.$validator.errors.add({
          field: "Consignee Address Cordinates",
          msg: "Could not find consignee address coordinates."
        });
      }

      if (this.rfqAssignees.length === 0) {
        this.$validator.errors.add({
          field: "Assingees",
          msg: "At least one assignee required before submitting."
        });
      }

      if (this.rfqAssignees.length > 1 && this.isContractRFQ) {
        this.$validator.errors.add({
          field: "Assignees",
          msg: "No more than one assignee required for contract RFQs."
        });
      }

      if (this.customercompanyentity == DIVA_COMPANY_ID && this.rfq.dispatchStatus != "FulFilled") {
        this.$validator.errors.add({
          field: "Assignees",
          msg: "Please fulfill this RFQ before releasing."
        });
      }

      if(this.errors.count() === 0 && this.overweightMsg.length === 0) this.saveRFQ(false);
    },


    saveRFQ: async function (draft) {
      const editingRFQ = await this.composeRFQ(draft);
      try {
          if (editingRFQ) {
            this.loading = true
            let response = null;
            if (this.isAdd) {
              editingRFQ.documents = await this.uploadAllDocuments(this.documents)
              response = await apiService.post('/rfq/save', editingRFQ);
            } else {
              response = await apiService.post('/rfq/update/' + this.rfqIdOnly, editingRFQ)   
            }

            if (response.status != 200) {
              Vue.toasted.success('Problem saving RFQ!', { duration: 5000 })
              this.loading = false
              return;
            } 

            Vue.toasted.success('Successfully Saved RFQ!', { duration: 5000 })
            sessionStorage.refresh = "true";
            sessionStorage.clearRFQ = "true";
            this.loading = false
            location.href="#/rfq/view";
          }
      }
      catch (error) {
        this.loading = false;
        let errorMessage = fixError(error);
        console.log(error);
        Vue.toasted.error('Error saving RFQ: ' + errorMessage, { duration: 8000 })
      }
    },

    composeRFQ: async function (draft) {
      console.log("composeRFQ");

      // remove blank assignee items
      for (var i = rfqAssignees.length - 1; i >= 0; i--) {
        if (rfqAssignees[i].assigneeid == null) {
          rfqAssignees.splice(i, 1)
        }
      }

      const processedAssignees = rfqAssignees.map(assignee => {
        const processedAssignee = Object.assign({}, assignee);
        processedAssignee.dueDateTime = newSafeDate(processedAssignee.duedate);
        delete processedAssignee.duedate;
        return processedAssignee;
      });

      JSON.stringify('rfqAssignees: ' + JSON.stringify(processedAssignees))
      var vStatus = 'Assigned';
      if (rfqAssignees.length === 0) {
        vStatus = 'Open'
      }

      var rootObj = this;

      var shippingunitarray = []

      var shippingunitarraylen = shippingunitarray.length
      if (shippingunitarraylen > 0) {
        for (var k = 0; k < shippingunitarraylen; k++) {
          shippingunitarray.pop()
        }
      }

      if (rows.length > 0) {
        for (var l = 0; l < rows.length; l++) {
          // Serialize Shipping Units with cargo array
          shippingunitarray.push({
            internalId: rows[l].internalId,
            description: rows[l].description,
            type: rows[l].type,
            quantity: rows[l].quantity,
            length: rows[l].length,
            width: rows[l].width,
            height: rows[l].height,
            weight: rows[l].weight,
            unitsofmeasure: this.shippingDimensionUnits,
            unitlength: rows[l].unitlength,
            unitweight: rows[l].unitweight,
            stackable: rows[l].stackable,
            apiIntegration: rows[l].apiIntegration,
            unitsPerCase: rows[l].unitsPerCase,
            lot: rows[l].lot,
            cargo: rows[l].cargorows,
            components: rows[l].components
          })
        }
      }

      var editingRFQ = {
        createdby: localStorage.getItem('local_id'),
        status: vStatus,
        dispatchStatus: this.rfq.dispatchStatus,
        density: this.rfq.density,
        densityclass: this.rfq.densityclass,
        totalWeight: this.rfq.totalWeight,
        totalWeightKg: this.rfq.totalWeightKg,
        customer: {
          entity: this.customerEntity,
          po: this.customerpo,
          sales: this.customersales,
          transferOrder: this.customertransferorder,
          address: this.customeraddress,
          postal: this.customerpostal,
          city: this.customercity,
          province: this.customerprovince,
          country: this.customercountry,
          company: this.customercompany,
          companyEntity: this.customercompanyentity,
          name: this.customername,
          division: this.customerdivision,
          terms: this.terms,
          dueDateTime: newSafeDate(this.duedate),
        },
        shipper: {
          company: this.companyname,
          companyEntity: this.shippercompanyentity,
          name: this.shippername,
          po: this.companypo,
          release: this.companyrelease,
          division: this.companydivision,
          entity: this.shipperentity,
          address: this.companyaddress,
          postal: this.companypostal,
          city: this.companycity,
          province: this.companyprovince,
          country: this.companycountry,

          pickupDateTime: newSafeDate(this.companyduedate),

          liftgate: this.companyliftgate,
          appointment: rootObj.appointment === 'Yes',
          contactname: rootObj.contactname,
          contactphone: rootObj.contactphone,

          addressCoordinates: this.companyAddressCoordinates
        },
        consignee: {
          company: this.consigneecompany,
          companyEntity: this.consigneeCompanyEntity,
          name: this.consigneename,
          po: this.consigneepo,
          division: this.consigneedivision,
          address: this.consigneeaddress,
          postal: this.consigneepostal,
          city: this.consigneecity,
          province: this.consigneeprovince,
          country: this.consigneecountry,
          entity: this.consigneeEntity,

          deliveryDateTime: newSafeDate(this.consigneedate),

          liftgate: this.consigneeliftgate,
          appointment: rootObj.consigneeappointment === 'Yes',
          contactname: rootObj.consigneecontactname,
          contactphone: rootObj.consigneecontactphone,

          addressCoordinates: this.consigneeAddressCoordinates
        },
        shippingunit: shippingunitarray,
        assignees: processedAssignees,
        truck: {
          trailertype: this.trailertype,
          suspensiontype: this.suspensiontype,
          tempcontrol: this.tempcontrol,
          liftgate: this.liftgate,
          driverassist: this.driverassist,
          mode: this.mode,
          service: this.service,
          dunnagerequired: this.dunnagerequired,
          cod: rootObj.truckcod === 'Yes',
          specialinstructions: this.specialinstructions
        },
        isContract: this.isContractRFQ
      };

      if (draft) {
        editingRFQ.status = 'Draft';

        // Show confirmation dialog modal if there are no items and there is netsuite integration for the customer
        // const emptyItems = isArrayForTransferOrderEmpty(shippingunitarray);
        // const netsuiteIntegration = this.customercompanyentity == DIVA_COMPANY_ID;
        // if(netsuiteIntegration && emptyItems && !confirm("Shipping Information is required to create a Transfer Order. Are you sure you want to save without this information?")){
        //  return null;
        // }
      }

      return editingRFQ;
    },


    cancelRFQ: function() {
      sessionStorage.clearRFQ = "true";
      location.href="#/rfq/view";
    },

    apptChange: function (event) {
      if (this.appointment === 'Yes') {
        // Enable the extra two fields
        document.getElementById('contactNameInput').style.display = 'block'
        document.getElementById('contactPhoneInput').style.display = 'block'
      } else {
        // Otherwise disable
        document.getElementById('contactNameInput').style.display = 'none'
        document.getElementById('contactPhoneInput').style.display = 'none'
      }
    },

    consigneeapptChange: function (event) {
      if (this.consigneeappointment === 'Yes') {
        // Enable the extra two fields
        document.getElementById('consigneecontactNameInput').style.display = 'block'
        document.getElementById('consigneecontactPhoneInput').style.display = 'block'
      } else {
        // Otherwise disable
        document.getElementById('consigneecontactNameInput').style.display = 'none'
        document.getElementById('consigneecontactPhoneInput').style.display = 'none'
      }
    },

    validationName(name, row) {
      return `${name}_${row.timestamp}`;
    },
    validationLabel(label, idx) {
      return `${label} (#${idx + 1})`;
    },
    validationErrorClass(name, row) {
      return {
        'has-error':this.errors.has(this.validationName(name, row))
      };
    },
    checkOverweight() {
      const msgs = [];
      if(!this.rows || !this.rows.length) return msgs;
      this.rows.forEach((row, idx) => {
        if(row.hasOverweightLvl && !this.isContractRFQ) msgs.push(`One shipping level of shipping unit #${idx + 1} is overweight (the content of one unit weighs more than the unit itself)`);
      });
      this.overweightMsg = msgs;
    },

    addFileToLocalDocuments(fileData) {
      if(this.documents) {
        this.documents.push(fileData);
      } else {
        this.documents = [fileData];
      }
    },
    deleteLocalDocument(index) {
      this.documents.splice(index, 1)
    },
    uploadAllDocuments: async function (documents) {
      if (!Array.isArray(documents)) return [];
      return await Promise.all(documents.map(async doc => {
        const signedResponse = await apiService.post('/rfq/signedUploadUrl', {
          fileName: doc.fileName
        });
        const {signedUrl, cloudName} = signedResponse.data;
        if(!signedUrl) {
          throw new Error("Unable to get signed upload url")
        }
        const headers = {
            'Content-Type': 'application/octet-stream'
        }
        await axios.put(signedUrl, doc.file, {headers});
        return {
          fileName: doc.fileName,
          uploadedBy: doc.uploadedBy,
          cloudName: cloudName,
          uploadedDate: moment(new Date()).format('LL')
        }
      }))
    },

    saveDocumentToRFQ: async function (fileData) {
      const response = await apiService.post(`/rfq/${this.rfqIdOnly}/document`, {fileData: fileData})
      this.documents = response.data;
    },
    deleteDocument: async function({rfqId, docId}) {
      if(!rfqId || !docId) return console.log('Unable to delete document. Missing Ids')
      const response = await apiService.delete(`/rfq/${rfqId}/document/${docId}`)
      this.documents = response.data;
    },

    fulfillShipment: async function () {
      this.fulfillErrorDetails = null;
      this.loading = true;
      try {
        // first save the RFQ
        const editingRFQ = await this.composeRFQ(true);
        if (editingRFQ != null) {

          // const response = await apiService.post('/rfq/update/' + this.rfqIdOnly, editingRFQ)      
          // if (response.status != 200) {
          //   Vue.toasted.error('Problem saving RFQ!', { duration: 5000 })
          //   this.loading = false;
          //   return;
          // } 
          sessionStorage.refresh = "true";

          // then try and fulfill it
          await apiService.post('/netsuite/writeFulfilmentRequest/' + this.rfqIdOnly);
          this.rfq.dispatchStatus = "FulFilled";

          // then send the item fulfillment email
          console.log('Sending fulfillment email...')    
          const emailResponse = await apiService.post('/kong/api/v1/email/itemFulfillment/', {}, {
            headers: { 'X-Raefton-RFQ-ID': this.rfqIdOnly }}
          );
          if (emailResponse.status != 200) {
            const errorMessage = emailResponse.data.message? JSON.stringify(emailResponse.data.message) : JSON.stringify(emailResponse)
            Vue.toasted.error('Error sending fulfillment email: ' + errorMessage, { duration: 5000 })
          }
        }
      } catch(err) {
        const errorDetails = fixError(err);
        console.log(errorDetails);
        this.fulfillErrorDetails = errorDetails;
        if (errorDetails.indexOf("at least one valid line item") > 0) {
          Vue.toasted.error('Either not enough in-stock items could be found to fulfill this transfer order, or this order has already been fulfilled.', { duration: 8000 });
        } else if (errorDetails.indexOf("Available lot #") > 0) {
          Vue.toasted.error('Please ensure the lot numbers are correct for this transfer order before fulfilling.', { duration: 8000 });
        } else if (errorDetails.indexOf("Invalid issueinventorynumber") > 0) {
          Vue.toasted.error('Netsuite does not like the lot number you have chosen. Please enter a different lot #.', { duration: 8000 });
        } else {
          Vue.toasted.error('There was a problem fulfilling the transfer order for this RFQ.', { duration: 8000 });
        }
      }
      this.loading = false;

    },

    resetCustomerCompany: function () {
      if (this.customercompany == "") {
        console.log('reset company');
        this.customercompany = "";
        this.customeraddress = "";
        this.customercity = "";
        this.customerprovince = "";
        this.customerpostal = "";
        this.customercountry = "";
      }
    },

    resetAssignee: function (i) {
      if (this.rfqAssignees[i].assigneeName == "") {
        console.log('remove assigneeid');
        this.rfqAssignees[i].assigneeid = "";
      }
      if (this.rfqAssignees[i].assigneeCompany == "") {
        console.log('remove assigneeCompanyId');
        this.rfqAssignees[i].assigneeCompanyId = "";
      }

      // reset whole object if everything is null
      if (this.rfqAssignees[i].assigneeName == "" && this.rfqAssignees[i].assigneeCompany == "") {
        this.rfqAssignees[i] = {};
      }
    },

    resetShipperCompany: function () {
      if (this.companyname == "") {
        console.log('reset shipper');
        this.companyname = "";
        this.companyaddress = "";
        this.companycity = "";
        this.companyprovince = "";
        this.companypostal = "";
        this.companycountry = "";
        this.companyAddressCoordinates = null;
      }
    },

    resetConsigneeCompany: function () {
      if (this.consigneecompany == "") {
        console.log('reset consignee');
        this.consigneecompany = "";
        this.consigneeaddress = "";
        this.consigneecity = "";
        this.consigneeprovince = "";
        this.consigneepostal = "";
        this.consigneecountry = "";
        this.consigneeAddressCoordinates = null;
      }
    }, 

    onDimensionChange: function() {
      console.log("________________onDimensionChange " + this.shippingDimensionUnits);
      const [lengthUnits, weightUnits] = this.shippingDimensionUnits.split('/');
      for (var i = 0; i < this.rows.length; i++) {
        rows[i].unitsofmeasure = this.shippingDimensionUnits;
        
        rows[i].unitlength = lengthUnits == 'undefined' ? '' : lengthUnits;
        rows[i].unitweight = weightUnits == 'undefined' ? '' : weightUnits;
        for (var j = 0; j < rows[i].components.length; j++) {
          rows[i].components[j].dimensionunit = lengthUnits == "in" ? 4 : 1;
          rows[i].components[j].weightunit = weightUnits == "kgs" ? 1 : 2;
        }
      }
      this.$forceUpdate();
    },

  },
}

function extractRFQId(rfqDotEntity)
{
  if (!rfqDotEntity || !rfqDotEntity.length) return null;
  return rfqDotEntity.split(".")[0];
}

</script>

<style scoped>
.customLiveSearch {
  z-index: 10;
}

.su-btn-link {
  padding: 4px;
}

.su-group-addon {
  background-color: #eee !important;
  border: 1px solid #ccc !important;
}

</style>



// WEBPACK FOOTER //
// edit.vue?b689e4d2